// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aCqk103GT0_DFX {
  align-items: center;
  row-gap: var(--ds-space-200, 16px);
  flex-direction: column;
  display: flex;
}

.aCqk103GT0_DFX h2, .aCqk103GT0_DFX p {
  width: 50%;
  margin: var(--ds-space-0, 0);
  text-align: center;
}

.aCqk103GT0_DFX h2 {
  font: var(--ds-font-heading-medium, 600 20px/28px var(--ds-font-family-heading, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif));
}

.aCqk103GT0_DFX p {
  font: var(--ds-font-body, normal 14px/20px -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif);
}

.aCqk103GT0_DFX .rOLpJQ5BpbsNv0 {
  width: 75%;
  margin-top: var(--ds-space-150, 12px);
  flex-direction: column;
  display: flex;
}

.aCqk103GT0_DFX .rOLpJQ5BpbsNv0 .PCZwTZDzIe_pzB {
  margin-bottom: var(--ds-space-075, 6px);
  color: var(--ds-text-subtle, #44546f);
  font: var(--ds-font-body, normal 14px/20px -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif);
}

.aCqk103GT0_DFX .rOLpJQ5BpbsNv0 .p0QKRSeUEFJasQ {
  width: 100%;
  padding: var(--ds-space-150, 12px);
  border: var(--ds-border-width, 1px) solid var(--ds-border, #091e4224);
  border-radius: var(--ds-radius-medium, 6px);
  background-color: var(--ds-surface, #fff);
  resize: none;
}

.aCqk103GT0_DFX .Mi26nyfGFhBZXs {
  justify-content: flex-end;
  width: 75%;
  display: flex;
}
`, ""]);
// Exports
export var container = `aCqk103GT0_DFX`;
export var textfieldContainer = `rOLpJQ5BpbsNv0`;
export var label = `PCZwTZDzIe_pzB`;
export var textarea = `p0QKRSeUEFJasQ`;
export var buttonContainer = `Mi26nyfGFhBZXs`;
export default ___CSS_LOADER_EXPORT___;
